import React from 'react';
import { Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, FormHelperText, TextField } from '@material-ui/core';
import { FORM_DICTIONARY } from './schemas/formFields';

const CALIFICACION_OPCIONES = [
    { value: 'excelente', label: 'Excelente' },
    { value: 'bueno', label: 'Bueno' },
    { value: 'regular', label: 'Regular' },
    { value: 'malo', label: 'Malo' }
];

const SI_NO_OPCIONES = [
    { value: 'si', label: 'SI' },
    { value: 'no', label: 'NO' }
];

export function FormularioSatisfaccion({ state, onChange, onError }) {
    const campos = FORM_DICTIONARY.satisfaccion;
    return (
        <Grid container spacing={3} style={{ marginTop: 10 }}>

            {/* Pregunta 1 */}
            <Grid item xs={12}>
                <FormControl component="fieldset" fullWidth error={onError(state.p1_satisfaccion.error)}>
                    <FormLabel component="legend">{campos.p1_satisfaccion.label}</FormLabel>
                    <RadioGroup name={campos.p1_satisfaccion.name} value={state.p1_satisfaccion.valor} onChange={onChange}>
                        {CALIFICACION_OPCIONES.map(op => (
                            <FormControlLabel key={op.value} value={op.value} control={<Radio />} label={op.label} />
                        ))}
                    </RadioGroup>
                    {state.p1_satisfaccion.error && <FormHelperText>{state.p1_satisfaccion.error}</FormHelperText>}
                </FormControl>
            </Grid>

            {/* Pregunta - Condicional */}
            {(state.p1_satisfaccion.valor === 'regular' || state.p1_satisfaccion.valor === 'malo') && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label={campos.p1_comentario_satisfaccion.label}
                        name={campos.p1_comentario_satisfaccion.name}
                        value={state.p1_comentario_satisfaccion.valor}
                        onChange={onChange}
                        error={onError(state.p1_comentario_satisfaccion.error)}
                        helperText={state.p1_comentario_satisfaccion.error}
                    />
                </Grid>
            )}

            {/* Pregunta 2 */}
            <Grid item xs={12}>
                <FormControl component="fieldset" fullWidth error={onError(state.p2_temas_pertinentes.error)}>
                    <FormLabel component="legend">{campos.p2_temas_pertinentes.label}</FormLabel>
                    <RadioGroup name={campos.p2_temas_pertinentes.name} value={state.p2_temas_pertinentes.valor} onChange={onChange}>
                        {SI_NO_OPCIONES.map(op => (
                            <FormControlLabel key={op.value} value={op.value} control={<Radio />} label={op.label} />
                        ))}
                    </RadioGroup>
                    {state.p2_temas_pertinentes.error && <FormHelperText>{state.p2_temas_pertinentes.error}</FormHelperText>}
                </FormControl>
            </Grid>

            {/* Pregunta  - Condicional */}
            {state.p2_temas_pertinentes.valor === 'no' && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label={campos.p2_comentario_temas.label}
                        name={campos.p2_comentario_temas.name}
                        value={state.p2_comentario_temas.valor}
                        onChange={onChange}
                        error={onError(state.p2_comentario_temas.error)}
                        helperText={state.p2_comentario_temas.error}
                    />
                </Grid>
            )}

            {/* Pregunta 3 */}
            <Grid item xs={12}>
                <FormControl component="fieldset" fullWidth error={onError(state.p3_estrategias_utiles.error)}>
                    <FormLabel component="legend">{campos.p3_estrategias_utiles.label}</FormLabel>
                    <RadioGroup name={campos.p3_estrategias_utiles.name} value={state.p3_estrategias_utiles.valor} onChange={onChange}>
                        {SI_NO_OPCIONES.map(op => (
                            <FormControlLabel key={op.value} value={op.value} control={<Radio />} label={op.label} />
                        ))}
                    </RadioGroup>
                    {state.p3_estrategias_utiles.error && <FormHelperText>{state.p3_estrategias_utiles.error}</FormHelperText>}
                </FormControl>
            </Grid>

            {/* Pregunta 3 - Condicional */}
            {state.p3_estrategias_utiles.valor === 'no' && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label={campos.p3_comentario_estrategias.label}
                        name={campos.p3_comentario_estrategias.name}
                        value={state.p3_comentario_estrategias.valor}
                        onChange={onChange}
                        error={onError(state.p3_comentario_estrategias.error)}
                        helperText={state.p3_comentario_estrategias.error}
                    />
                </Grid>
            )}

            {/* Pregunta 4 */}
            <Grid item xs={12}>
                <FormControl component="fieldset" fullWidth error={onError(state.p4_comunicacion.error)}>
                    <FormLabel component="legend">{campos.p4_comunicacion.label}</FormLabel>
                    <RadioGroup name={campos.p4_comunicacion.name} value={state.p4_comunicacion.valor} onChange={onChange}>
                        {CALIFICACION_OPCIONES.map(op => (
                            <FormControlLabel key={op.value} value={op.value} control={<Radio />} label={op.label} />
                        ))}
                    </RadioGroup>
                    {state.p4_comunicacion.error && <FormHelperText>{state.p4_comunicacion.error}</FormHelperText>}
                </FormControl>
            </Grid>

            {/* Pregunta 4 - Condicional */}
            {(state.p4_comunicacion.valor === 'regular' || state.p4_comunicacion.valor === 'malo') && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label={campos.p4_comentario_comunicacion.label}
                        name={campos.p4_comentario_comunicacion.name}
                        value={state.p4_comentario_comunicacion.valor}
                        onChange={onChange}
                        error={onError(state.p4_comentario_comunicacion.error)}
                        helperText={state.p4_comentario_comunicacion.error}
                    />
                </Grid>
            )}

            {/* Pregunta 5  */}
            <Grid item xs={12}>
                <FormControl component="fieldset" fullWidth error={onError(state.p5_formacion_integral.error)}>
                    <FormLabel component="legend">{campos.p5_formacion_integral.label}</FormLabel>
                    <RadioGroup name={campos.p5_formacion_integral.name} value={state.p5_formacion_integral.valor} onChange={onChange}>
                        {SI_NO_OPCIONES.map(op => (
                            <FormControlLabel key={op.value} value={op.value} control={<Radio />} label={op.label} />
                        ))}
                    </RadioGroup>
                    {state.p5_formacion_integral.error && <FormHelperText>{state.p5_formacion_integral.error}</FormHelperText>}
                </FormControl>
            </Grid>

            {/* Pregunta 5 - Condicional */}
            {state.p5_formacion_integral.valor === 'no' && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label={campos.p5_comentario_formacion.label}
                        name={campos.p5_comentario_formacion.name}
                        value={state.p5_comentario_formacion.valor}
                        onChange={onChange}
                        error={onError(state.p5_comentario_formacion.error)}
                        helperText={state.p5_comentario_formacion.error}
                    />
                </Grid>
            )}

            {/* Pregunta 6 */}
            <Grid item xs={12}>
                <FormControl component="fieldset" fullWidth error={onError(state.p6_atencion_servicio.error)}>
                    <FormLabel component="legend">{campos.p6_atencion_servicio.label}</FormLabel>
                    <RadioGroup name={campos.p6_atencion_servicio.name} value={state.p6_atencion_servicio.valor} onChange={onChange}>
                        {CALIFICACION_OPCIONES.map(op => (
                            <FormControlLabel key={op.value} value={op.value} control={<Radio />} label={op.label} />
                        ))}
                    </RadioGroup>
                    {state.p6_atencion_servicio.error && <FormHelperText>{state.p6_atencion_servicio.error}</FormHelperText>}
                </FormControl>
            </Grid>

            {/* Pregunta 6 - Condicional */}
            {(state.p6_atencion_servicio.valor === 'regular' || state.p6_atencion_servicio.valor === 'malo') && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label={campos.p6_comentario_atencion.label}
                        name={campos.p6_comentario_atencion.name}
                        value={state.p6_comentario_atencion.valor}
                        onChange={onChange}
                        error={onError(state.p6_comentario_atencion.error)}
                        helperText={state.p6_comentario_atencion.error}
                    />
                </Grid>
            )}

            {/* Pregunta 7 */}
            <Grid item xs={12}>
                <FormControl component="fieldset" fullWidth error={onError(state.p7_bienestar_emocional.error)}>
                    <FormLabel component="legend">{campos.p7_bienestar_emocional.label}</FormLabel>
                    <RadioGroup name={campos.p7_bienestar_emocional.name} value={state.p7_bienestar_emocional.valor} onChange={onChange}>
                        {SI_NO_OPCIONES.map(op => (
                            <FormControlLabel key={op.value} value={op.value} control={<Radio />} label={op.label} />
                        ))}
                    </RadioGroup>
                    {state.p7_bienestar_emocional.error && <FormHelperText>{state.p7_bienestar_emocional.error}</FormHelperText>}
                </FormControl>
            </Grid>

            {/* Pregunta 7 - Condicional */}
            {state.p7_bienestar_emocional.valor === 'no' && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label={campos.p7_comentario_bienestar.label}
                        name={campos.p7_comentario_bienestar.name}
                        value={state.p7_comentario_bienestar.valor}
                        onChange={onChange}
                        error={onError(state.p7_comentario_bienestar.error)}
                        helperText={state.p7_comentario_bienestar.error}
                    />
                </Grid>
            )}

            {/* Pregunta 8 */}
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label={campos.p8_mejoras.label}
                    name={campos.p8_mejoras.name}
                    value={state.p8_mejoras.valor}
                    onChange={onChange}
                    error={onError(state.p8_mejoras.error)}
                    helperText={state.p8_mejoras.error}
                />
            </Grid>
        </Grid>
    );
}
